
$(document).on('click', '.disablefilter label', function(e) {
  e.preventDefault();
  e.stopPropagation();
  return false;
});

$(document).on('change', '.disablefilter input[type="checkbox"]', function(e) {
  e.preventDefault();
  e.stopPropagation();
  $(this).prop('checked', false);
});
 
$(document).ready(function () {

 const normalize = str =>
  str.replace(/\s+/g, '')
     .replace(/[–—−]/g, '-')
     .toLowerCase();


const csrtMoreValues = [];
$('details.csrt--More .details__content ul li input').each(function () {
  const val = $(this).val() || '';
  csrtMoreValues.push(normalize(val));
});


$('.filter-tagcsrt .details__content ul.list li').each(function () {
  const $li = $(this);
  const input = $li.find('input');
  const tagValue = normalize(input.attr('data-tag') || input.val() || '');


  const isMatch = csrtMoreValues.some(value => value.includes(tagValue));

  if (isMatch) {
    $li.removeClass('disablefilter').addClass('factivefilter');
    input.prop('disabled', false); // Enable checkbox
  } else {
    $li.removeClass('factivefilter').addClass('disablefilter');
    input.prop('disabled', true); // Disable checkbox
  }
});

const allowedRawRanges = ['0+–+2', '2+–+4', '4+–+6', '6+–+8', '8+–+up'];

function formatTag(raw) {
  return raw.trim()
    .replace(/\s*[-–—−]\s*/g, '+–+') // Normalize dash to en-dash
    .replace(/\s+/g, '+')
    .replace('Mercedes+Benz', 'Mercedes');
}

$(document).off('click', '.filter-tagcsrt .details__content ul.list li')
  .on('click', '.filter-tagcsrt .details__content ul.list li', function (e) {
    const $li = $(this);
    const clickedInput = $li.find('input');
    const tagLabel = $li.find('label').text().trim();

    if (!$(e.target).is('input')) {
      clickedInput.prop('checked', !clickedInput.prop('checked'));
    }

    const selectedTags = [];
    $('.filter-tagcsrt input[type="checkbox"]:checked').each(function () {
      const raw = $(this).attr('data-tag') || $(this).val();
      const formatted = formatTag(raw);

      if (!selectedTags.includes(formatted)) {
        selectedTags.push(formatted); 
      }
    });

    $('#FacetFiltersActive .removable-facet').each(function () {
      const tag = $(this).attr('data-tag');
      if (!selectedTags.includes(tag)) {
        $(this).remove();
      }
    });

    console.log('Unique Selected Tags:', selectedTags);
   

    if (selectedTags.length > 0) {
      const selectedValue = $('#FacetFormSortBy-drawer').val();
      const baseURL = window.location.origin + window.location.pathname;

      const queryParams = [`sort_by=${selectedValue}`];
      selectedTags.forEach(tag => {
        if (allowedRawRanges.includes(tag)) {
          console.log("tag is tested",tag)
              if (tag === '6+–+8') {
                queryParams.push('filter.p.tag=6+-+8');
           } else{
          queryParams.push(`filter.p.tag=${tag}`);
              }
        } else {
          console.log("tag is tested else",tag)
          if(tag == 'Maserati'){
            tag = 'Maserati Sport 12V Parts'
          }
      
          
          queryParams.push(`filter.p.tag=${encodeURIComponent(tag)}`);
        }
      });

      const finalURL = `${baseURL}?${queryParams.join('&')}`;
      console.log('Final AJAX URL:', finalURL);
        window.history.replaceState(null, '', finalURL);

      $.ajax({
        url: finalURL,
        method: 'GET',
        success: function (response) {
          const htmlContent = $('<div>').html(response).find('.collection__content.flex').html();

          setTimeout(function () {
            $('.collection__content.flex').html(htmlContent);

            selectedTags.forEach(function (tag, index) {
              const label = $('.filter-tagcsrt input[type="checkbox"]:checked')
                .eq(index).closest('li').find('label').text().trim();

              $(`div#FacetFiltersActive .removable-facet[data-tag="${tag}"]`).remove();

              const facetHTML = `
                <div class="removable-facet flex items-center justify-between gap-3 lg:gap-4 text-xs lg:text-sm leading-none rounded-full" data-tag="${tag}">
                  <div class="facet-title flex items-center gap-2">${label}</div>
                  <a class="block relative remove-filter" href="${baseURL}?sort_by=${selectedValue}" aria-label="Remove filter" data-tag="${tag}">
                    <span class="btn-text">
                      <svg class="icon icon-remove icon-xs" viewBox="0 0 10 10" stroke="currentColor" fill="none">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m1 9 8-8M1 1l8 8"></path>
                      </svg>
                    </span>
                  </a>
                </div>
              `;
              $('div#FacetFiltersActive').append(facetHTML);
            });

          }, 500);
        },
        error: function () {
          console.error("Failed to apply filter.");
        }
      });
    }
  });

//  REMOVE TAG WITHOUT RELOAD
$(document).on('click', '.remove-filter', function (e) {
  e.preventDefault();
  const removedTag = $(this).attr('data-tag');

  
  $('.filter-tagcsrt input[type="checkbox"]').each(function () {
    const raw = $(this).attr('data-tag') || $(this).val();
    const formatted = formatTag(raw);
    if (formatted === removedTag) {
      $(this).prop('checked', false);
    }
  });

  
  const selectedTags = [];
  $('.filter-tagcsrt input[type="checkbox"]:checked').each(function () {
    const raw = $(this).attr('data-tag') || $(this).val();
    const formatted = formatTag(raw);
    if (!selectedTags.includes(formatted)) {
      selectedTags.push(formatted);
    }
  });

  
  $(`#FacetFiltersActive .removable-facet[data-tag="${removedTag}"]`).remove();

  const selectedValue = $('#FacetFormSortBy-drawer').val();
  const baseURL = window.location.origin + window.location.pathname;

  const queryParams = [`sort_by=${selectedValue}`];
  selectedTags.forEach(tag => {
    if (allowedRawRanges.includes(tag)) {
      queryParams.push(`filter.p.tag=${tag}`);
    } else {
      queryParams.push(`filter.p.tag=${encodeURIComponent(tag)}`);
    }
  });

  const finalURL = `${baseURL}?${queryParams.join('&')}`;
  console.log('Final AJAX URL after removal:', finalURL);
window.history.replaceState(null, '', finalURL);

  $.ajax({
    url: finalURL,
    method: 'GET',
    success: function (response) {
      const htmlContent = $('<div>').html(response).find('.collection__content.flex').html();
      setTimeout(function () {
        $('.collection__content.flex').html(htmlContent);
      }, 500);
    },
    error: function () {
      console.error("Failed to apply filter after removing tag.");
    }
  });
});

  
});